import { LegalEntityCountry } from '@seapoint/server/enums';
import { ColumnDef } from '@tanstack/react-table';
import { Avatar } from '../../../../../design-system/avatar/avatar/avatar';
import { ColumnHeaderWithSorting } from '../../../../../design-system/data-table/column-header-with-sorting';
import { EmployeeView } from '../../../../../types/entity-types';
import { getCountryFlag } from '../../../../../utils/get-country-flag';
import { getBeneficiaryCountryDetails } from '../../../../payments/utils/get-beneficiary-country-details';

export const firstNameId = 'firstName';

export const employeeTableColumnDefinition: ColumnDef<EmployeeView>[] = [
  {
    accessorKey: firstNameId,
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="Full Name" />,
    cell: ({ row }) => {
      const employee = row.original;
      const fullName = `${employee.firstName} ${employee.lastName}`;

      return (
        <div className="-my-2 flex items-center gap-3">
          <Avatar name={fullName} size="sm" />
          <span>{fullName}</span>
        </div>
      );
    },
    size: 25,
  },
  {
    accessorKey: 'employeeId',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="ID" />,
    cell: ({ row }) => <span>{row.original.employeeId}</span>,
    size: 20,
  },
  {
    accessorKey: 'role',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="Role" />,
    cell: ({ row }) => <span>{row.original.role || '-'}</span>,
    size: 25,
  },
  {
    accessorKey: 'country',
    header: ({ column }) => <ColumnHeaderWithSorting column={column} label="Country" />,
    cell: ({ row }) => {
      const country = row.original.country;
      const flag = getCountryFlag(country as unknown as LegalEntityCountry);

      return (
        <div className="flex items-center gap-2">
          {flag && <img src={flag} alt={country} className="h-5 w-5 rounded-full object-cover" />}
          <span>{getBeneficiaryCountryDetails(country).name}</span>
        </div>
      );
    },
    size: 20,
  },
];
